import Footer from '../components/Footer';
import Profileinterno from './Profileinterno';
import Testimoniodev from './Testimoniodev';
import Testimoniourgencias from './Testimoniourgencias';
import Urgenview from './Urgenview';

const Developers = () => {
    return(
      
        <div>
      
        <div>
        <Profileinterno/>
          </div>
  
      
  <Testimoniodev/>
  
  </div>
   
    )
}
export default Developers